import { useAuth } from '../context/AuthContext';
import { FeatureFlag, useFeatureFlags } from '../contexts/FeatureFlagsContext';
import { useProCountryFeatures } from './useProCountryFeatures';

/**
 * Pension / hébergement : activé pour le compte, autorisé pour le pays,
 * et non coupé par le flag global BOARDING_MODULE (DB).
 */
export function useBoardingModuleVisible(): boolean {
  return useBoardingModuleGate().visible;
}

/**
 * Évite les redirections /app/services tant que le profil pro n'est pas hydraté
 * (accès direct /app/stay/:id, /app/pension).
 */
export function useBoardingModuleGate(): { visible: boolean; ready: boolean } {
  const { user, isLoading } = useAuth();
  const { isFeatureEnabled } = useFeatureFlags();
  const { boarding } = useProCountryFeatures();
  const ready = !isLoading;
  const visible = Boolean(
    boarding &&
      user?.is_boarding_enabled &&
      isFeatureEnabled(FeatureFlag.BOARDING_MODULE)
  );
  return { visible, ready };
}
